module.exports = __webpack_public_path__ + "img/cookies.33f8686a.svg";